import { A11y, EffectFade, Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { html } from 'common-tags'

export default (props = {
    slideClassName: null,
    wrapperClassName: null,
    onSwiper: null
}) => {
    const {
        slideClassName,
        wrapperClassName,
        onSwiper,
        ...renderProps
    } = props

    return (
        <Swiper
            a11y
            breakpoints={!renderProps.slidesPerView
                ? { 1024: { slidesPerView: 2 } }
                : null}
            modules={[A11y, EffectFade, Navigation, Pagination]}
            navigation
            pagination={{
                clickable: true
            }}
            slidesPerView="auto"
            spaceBetween={0}
            wrapperTag="ul"
            focusableElements={[
                'input',
                'select',
                'option',
                'textarea',
                'button',
                'video',
                'label',
                'a'
            ].join(', ')}
            onSwiper={(swiper) => {
                const wrapperClass = `swiper-wrapper${wrapperClassName
                    ? ` ${wrapperClassName}`
                    : `${!slideClassName
                            || slideClassName.match(/\s*col(?:\s|-\d)/)
                        ? ' row'
                        : ''}`}`

                if (swiper.wrapperEl.className !== wrapperClass)
                    swiper.wrapperEl.className = wrapperClass

                if (swiper.navigation.prevEl
                        && !swiper.navigation.prevEl.innerHTML)
                    swiper.navigation.prevEl.innerHTML = html`
                        <svg
                            width="24"
                            height="24"
                        >
                            <use xlink:href="#icon-chevron-left" />
                        </svg>
                    `

                if (swiper.navigation.nextEl
                        && !swiper.navigation.nextEl.innerHTML)
                    swiper.navigation.nextEl.innerHTML = html`
                        <svg
                            width="24"
                            height="24"
                        >
                            <use xlink:href="#icon-chevron-right" />
                        </svg>
                    `

                if (renderProps.autoHeight
                        && swiper.height
                            !== swiper.slides[swiper.realIndex].clientHeight)
                    setTimeout(() =>
                        swiper.updateAutoHeight(swiper.params.speed),
                    swiper.params.speed * 1.5)

                swiper.$el[0]
                    .addEventListener('focusin', (e) => {
                        if (!e.target.classList.contains('focus-visible'))
                            return

                        document.body.scrollLeft = 0

                        const activeSlide = swiper.slides
                            .filter(el => el === e.target
                                || el.contains(e.target))[0]

                        const activeIdx = activeSlide
                            && swiper.slides.indexOf(activeSlide)

                        if (!(activeIdx >= 0)
                                || swiper.activeIndex === activeIdx)
                            return

                        swiper.slideTo(activeIdx)
                    })

                if (typeof onSwiper === 'function')
                    onSwiper(swiper)
            }}
            {...renderProps}
        >
            {Array.from(props.children || [])
                .filter(obj => obj)
                .map((Child, idx) => (
                    <SwiperSlide
                        tag="li"
                        className={slideClassName
                            || 'display-flex col-10 col-7-md col-6-lg-up'}
                        key={`swiper-slide-${idx}`}
                    >
                        {Child}
                    </SwiperSlide>
                ))}
        </Swiper>
    )
}
